export const EMAIL_SYNC_CADENCE_MIN_MINUTES = 5;
export const EMAIL_SYNC_CADENCE_MAX_MINUTES = 1440;
export const EMAIL_SYNC_CADENCE_INCREMENT_MINUTES = 5;

export const validateEmailSyncCadence = (cadenceMinutes) => {
	const value = Number(cadenceMinutes);

	const isBelowMinimum = value < EMAIL_SYNC_CADENCE_MIN_MINUTES;
	const isAboveMaximum = value > EMAIL_SYNC_CADENCE_MAX_MINUTES;
	const isInvalidIncrement =
		!Number.isInteger(value) ||
		value % EMAIL_SYNC_CADENCE_INCREMENT_MINUTES !== 0;

	let errorMessage;

	if (isBelowMinimum) {
		errorMessage = 'Cadence cannot be less than 5 minutes';
	} else if (isAboveMaximum) {
		errorMessage = 'Cadence cannot exceed 24 hours';
	} else if (isInvalidIncrement) {
		errorMessage = 'Cadence must be in 5-minute increments';
	}

	return {
		isValid: !isBelowMinimum && !isAboveMaximum && !isInvalidIncrement,
		errorMessage,
		value,
	};
};

export const getEmailSyncCadenceDisplay = (minutes) => {
	const cadenceMinutes = Number(minutes ?? EMAIL_SYNC_CADENCE_MIN_MINUTES);

	if (cadenceMinutes >= 60 && cadenceMinutes % 60 === 0) {
		return {
			value: cadenceMinutes / 60,
			unit: 'hours',
		};
	}

	return {
		value: cadenceMinutes,
		unit: 'minutes',
	};
};

export const getEmailSyncCadenceMinutes = ({ value, unit }) => {
	if (value === '') {
		return 0;
	}

	const numericValue = Number(value);

	return unit === 'hours' ? numericValue * 60 : numericValue;
};